import {
  PagedResponse_ExchangeRateRangeListResponse,
  PagedResponse_RecommendedRateResponse,
} from '@acme/api';
import { useCallback, useState } from 'react';
import {
  ExchangeRateFilter,
  exchangeRateStore,
  RecommendedRateFilter,
} from './model';

export const useExchangeRate = () => {
  const [exchangeRates, setExchangeRates] =
    useState<PagedResponse_ExchangeRateRangeListResponse | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const loadExchangeRates = useCallback(async (filter: ExchangeRateFilter) => {
    try {
      setIsLoading(true);
      const rates = await exchangeRateStore.getExchangeRates(filter);
      setExchangeRates(rates);
      return rates;
    } catch (err) {
      setError(
        err instanceof Error ? err : new Error('Failed to exchange rates')
      );
    } finally {
      setIsLoading(false);
    }
  }, []);

  return { exchangeRates, isLoading, loadExchangeRates, error };
};

export const useRecommendedRate = () => {
  const [recommendedRates, setRecommendedRates] =
    useState<PagedResponse_RecommendedRateResponse | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const loadRecommendedRates = useCallback(
    async (filter: RecommendedRateFilter) => {
      try {
        setIsLoading(true);
        const rates =
          await exchangeRateStore.getRecommendedExchangeRates(filter);
        setRecommendedRates(rates);
        return rates;
      } catch (err) {
        setError(
          err instanceof Error ? err : new Error('Failed to exchange rates')
        );
      } finally {
        setIsLoading(false);
      }
    },
    []
  );

  return { recommendedRates, loadRecommendedRates, isLoading, error };
};
